(function () {
  'use strict';
  var script = document.querySelector('script[data-pc-cart-review-route]');
  if (!script) return;
  var route = script.getAttribute('data-pc-cart-review-route');
  var label = script.getAttribute('data-pc-cart-review-label');
  function addReviewLink() {
    document.querySelectorAll('.Vtl-CartDrawer button.checkout-button').forEach(function (button) {
      var drawer = button.closest('.Vtl-CartDrawer');
      if (!drawer.querySelector('[data-pc-cart-review-link]')) {
        var link = document.createElement('a');
        link.href = route;
        link.className = 'btn pc-cart-review-link';
        link.setAttribute('data-pc-cart-review-link', '');
        link.textContent = label;
        button.insertAdjacentElement('afterend', link);
      }
      drawer.classList.add('pc-cart-review-ready');
    });
  }
  addReviewLink();
  new MutationObserver(addReviewLink).observe(document.body, {childList:true,subtree:true});
})();
